import useSettings from "app/hooks/useSettings";
import MatxSuspense from "../MatxSuspense";
import { MatxLayouts } from "./index";
import AppContexts from "app/contexts/AppContexts";
import { useEffect } from "react";
import useAuth from "app/hooks/useAuth";
import { identifyUser } from "app/analytics";
import { pushUserIdentified } from "app/dataLayer";
import useAccounts from "app/hooks/app/useAccounts";

export default function MatxLayout(props) {
  const { settings } = useSettings();
  const Layout = MatxLayouts[settings.activeLayout];
  const { user } = useAuth();
  const { account } = useAccounts();

  useEffect(() => {
    if (user && account) {
      identifyUser(user.userId, account.id, account.name);
      pushUserIdentified(user.userId, account.id, account.name, user.role);
    }
  }, [user, account]);
  return (
    <MatxSuspense>
      <AppContexts>
        <Layout {...props} />
      </AppContexts>
    </MatxSuspense>
  );
}
